module.exports = __webpack_public_path__ + "static/12-df769eeb2b8966805d8e2f4b5b00e5bd.png";